<template>
	<GetApp :mobile-type="mobileType" :icon-path="appleStoreIcon" :download-path="appleStoreDownloadPath" />
</template>
<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import GetApp from '@views/mobile/get-app.vue';
import { SupportedMobile } from 'types/mobile';

const mobileType: SupportedMobile = 'iPhone';

const appleStoreIcon = `${appCloudfrontPath}/images/Download_on_the_App_Store_Badge_US-UK_blk_092917.png`;
const appleStoreDownloadPath = `${import.meta.env.VITE_AVATAR_URL}/app-store-redirect`;
</script>
